/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */
import { get } from "lodash";
import { Flex } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";
import useTagsVisibleInFilter from "src/app/Restricted/useTagsVisibleInFilter";
import { useAuth0 } from "src/contexts/auth0Provider";
import {
  useWorkspace,
  useWorkspaceFeatureFlags,
} from "src/contexts/global/WorkspaceContext";
import { ModalProvider } from "src/contexts/withModal";
import useUpdateTeamDetails from "src/hooks/useUpdateTeamDetails";
import TeamDescription from "src/pages/TeamPage/sub-components/TeamDetailsPanel/TeamDescription";
import TeamTagsSections from "src/pages/TeamPage/sub-components/TeamDetailsPanel/TeamTagsSections";

import withTeam from "../DataProviderHOCs/withTeam";

const CanvTeamDescription = withTeam(({ team, refetch }) => {
  const workspace = useWorkspace();
  const { user } = useAuth0();
  const tagsVisibleIn = useTagsVisibleInFilter();
  const groupTypes = workspace?.config?.groupTypes;

  const {
    handleUpdateTeamDetails,
    canUpdateGroupAttributes,
    editDetailsMode,
    setEditDetailsMode,
  } = useUpdateTeamDetails({ team, refetch });

  const featureFlags = useWorkspaceFeatureFlags();

  return (
    <ModalProvider>
      <Flex alignItems="center" flexWrap="wrap" gap="r">
        <TeamDescription
          attributes={get(team, "attributes")}
          loading={false}
          canUpdateGroupAttributes={canUpdateGroupAttributes}
          groupTypes={groupTypes}
          featureFlags={featureFlags}
          handleUpdateTeamDetails={handleUpdateTeamDetails}
          editDetailsMode={editDetailsMode}
          setEditDetailsMode={setEditDetailsMode}
        />
        <TeamTagsSections
          team={team}
          user={user}
          tagsVisibleIn={tagsVisibleIn}
          featureFlags={featureFlags}
        />
      </Flex>
    </ModalProvider>
  );
});

CanvTeamDescription.propTypes = {
  channel: PropTypes.string.isRequired,
};

export default CanvTeamDescription;
